import { Bot } from 'lucide-react'

import { UserAvatar } from '@/components/ui/user-avatar'
import type { SalesLeadActivity } from '@/models/salesLead'

// Self-hosted on our public static bucket (static.cai.insure) so we don't depend
// on phonic.ai's CDN or hit a cross-origin fetch for the activity author icon.
const PHONIC_ICON_URL = 'https://static.cai.insure/logo-phonic.svg'

/**
 * Author icon shown before an activity's author name: the Phonic logo for
 * automation calls, a bot glyph for the system user, otherwise the person's
 * uploaded headshot (Settings → Your photo), falling back to their legacy
 * avatar and then to initials.
 */
export function ActivityAuthorIcon({ activity }: { activity: SalesLeadActivity }) {
  if (activity.createdByKind === 'phonic') {
    return (
      <img
        src={PHONIC_ICON_URL}
        alt="Phonic"
        className="mr-1.5 inline-block size-6 rounded-full align-middle"
      />
    )
  }
  if (activity.createdByKind === 'system') {
    return (
      <span className="bg-muted text-muted-foreground mr-1.5 inline-flex size-6 items-center justify-center rounded-full align-middle">
        <Bot className="size-4" />
      </span>
    )
  }
  return (
    <UserAvatar
      name={activity.createdByName || '?'}
      src={activity.createdByAvatar}
      className="mr-1.5 inline-flex size-6 align-middle"
      fallbackClassName="text-[11px]"
    />
  )
}
